module.exports = __webpack_public_path__ + "font-awesome.674f50d287a8c48dc19b.eot";


//////////////////
// WEBPACK FOOTER
// G:/3csoft/client-final/src/fonts/font-awesome/font-awesome.eot
// module id = ../../../../../src/fonts/font-awesome/font-awesome.eot
// module chunks = styles